import React, { useState, useEffect } from "react";
import axios from 'axios'
import Swal from 'sweetalert2';

import Guest from "../../../layouts/Guest";
import { getEventPin, handlePinAuthError } from "../../../utils/pinAuth";
import CheckInConfirmation from "../../../components/Private/CheckIn/CheckInConfirmation";
import { useGuestContext } from '../../../contexts/GuestContext';

function EventCheckInPage() {
  const [details, setDetails] = useState(null);
  const [guestId, setGuestId] = useState(null);
  const { language } = useGuestContext();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    // First, try to get 'guestid' from the URL
    let id = params.get('guestid');
    // If 'guestid' is not found, try to get 'id' instead
    if (!id) {
      id = params.get('id');
    }
    // Proceed if any of the IDs were found
    if (id) {
      setGuestId(id); // Make sure this matches your state setter function name
      fetchGuestDetails(id);
    }
  }, []);
  

  const fetchGuestDetails = async (guestId) => {
    try {
      const pin = await getEventPin();
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/event/checkinrequest?guestid=${guestId}`, {
        headers: { 'X-Event-Pin': pin }
      });
      if (response.data && response.data.status === 'success') {
        console.log(response.data.details)
        setDetails(response.data.details);
      } else if (response.data && response.data.status === 'checkedIn') {
        // Guest is already checked in
        const checkedInTime = response.data.details.checkedInTime || 'Unknown time';
        Swal.fire({
          title: language === "English" ? `Guest already checked in` : `居士已報到`,
          text: language === "English" ? `The guest with ID: ${guestId} has already checked in at ${checkedInTime}.` : `ID為${guestId}的居士已於 ${checkedInTime} 報到。`,
          icon: 'warning',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        }).then(() => {
          window.location.href = '/checkinSearch';
        });
      } else {
        // The server says why it refused; "not found" is only one of the reasons.
        const messages = {
          sessionClosed: {
            title: language === "English" ? "Check-in is not open" : "目前不在報到時段",
            text: language === "English"
              ? "No session is open for check-in right now. Check-in opens 90 minutes before each session starts."
              : "目前不在任何共修的報到時段內。報到於每場開始前90分鐘開放。"
          },
          notRegistered: {
            title: language === "English" ? "Not registered for this session" : "未報名本場次",
            text: language === "English"
              ? `Guest ID: ${guestId} did not sign up for the session currently open.`
              : `ID為${guestId}的居士未報名目前開放報到的場次。`
          }
        };
        const fallback = {
          title: language === "English" ? `The Guest with ID: ${guestId} not found` : `未找到ID為${guestId}的居士`,
          text: language === "English" ? "Please ensure the guest has completed the registration" : "請確認這位居士已完成報名"
        };
        const { title, text } = messages[response.data?.reason] || fallback;
        Swal.fire({
          title,
          text,
          icon: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        }).then(() => {
          window.location.href = '/checkinSearch';
        });
      }
    } catch (error) {
      if (error.response?.status === 401) {
        handlePinAuthError();
        return;
      }
      Swal.fire('Error', 'An error occurred while fetching data', 'error');
    }
  };


  return (
    <>
      <Guest>
        {details && <CheckInConfirmation details={details} />}
      </Guest>
    </>
  );
}

export default EventCheckInPage;
